package dairy.mynotes.reusablecomponents

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import dairy.mynotes.ui.theme.AppColors

@Composable
fun Label(text: String, modifier: Modifier = Modifier,
          textStyle: androidx.compose.ui.text.TextStyle = MaterialTheme.typography.displaySmall,
          color: androidx.compose.ui.graphics.Color = AppColors.OnSecondary
          ) {
    Text(
        text = text,
        modifier = modifier,
        style = textStyle,
        color = color
    )
}